import itemDefService from '@/services/itemDefService';
import { useRequest } from '@umijs/max';

// export default (): {
//   itemDefs: API.Service.ItemDef[];
//   itemDefsLoading: boolean;
//   allItemDefs: API.Service.ItemDef[];
//   refreshItemDefs: () => Promise<API.Service.ItemDef[]>;
//   fetchItemDefs: () => Promise<API.Service.ItemDef[]>;
//   loading: boolean;
//   itemDefsGroupedBySponsor: API.Service.ItemDefGroupedBySponsor[];
//   itemDefsWithSponsor: API.Service.ItemDefWithSponsor[];
// } => {
//   const {
//     allSponsorDefinitionItems,
//     sponsorsItemsLoading,
//     sponsors,
//     sponsorsLoading,
//   } = useModel('sponsors', (model) => ({
//     allSponsorDefinitionItems: model.allSponsorDefinitionItems,
//     sponsorsItemsLoading: model.itemsLoading,
//     sponsors: model.sponsors,
//     sponsorsLoading: model.sponsorsLoading,
//   }));

//   const {
//     data: itemDefs,
//     loading: itemDefsLoading,
//     refresh: refreshItemDefs,
//     run: fetchItemDefs,
//   } = useRequest(async () => {
//     const res = await itemDefService.getItemDefs();
//     return res;
//   });

//   const allItemDefs: API.Service.ItemDef[] = useMemo(() => {
//     const filteredItemDefs =
//       itemDefs?.filter(
//         (itemDef) =>
//           !allSponsorDefinitionItems.some(
//             (sponsorDefinition) => sponsorDefinition.id === itemDef.id,
//           ),
//       ) || [];

//     return [
//       ...filteredItemDefs,
//       ...allSponsorDefinitionItems,
//     ] as API.Service.ItemDef[];
//   }, [allSponsorDefinitionItems, itemDefs]);

//   const loading = useMemo(() => {
//     return itemDefsLoading || sponsorsItemsLoading || sponsorsLoading;
//   }, [itemDefsLoading, sponsorsItemsLoading, sponsorsLoading]);

//   const itemDefsGroupedBySponsor = useMemo(() => {
//     const otherItemDefs = allItemDefs.filter(
//       (itemDef) =>
//         !sponsors?.some((sponsor) => sponsor.id === itemDef.sponsorId),
//     );

//     const itemDefsGroupedBySponsor: API.Service.ItemDefGroupedBySponsor[] =
//       sponsors?.map((sponsor) => {
//         return {
//           ...sponsor,
//           itemDefs: allItemDefs.filter(
//             (itemDef) => itemDef.sponsorId === sponsor.id,
//           ),
//         };
//       }) || [];

//     itemDefsGroupedBySponsor.push({
//       id: 'other',
//       name: 'Other',
//       itemDefs: otherItemDefs,
//     });

//     return itemDefsGroupedBySponsor;
//   }, [sponsors, allItemDefs]);

//   const itemDefsWithSponsor = useMemo(() => {
//     return (
//       itemDefs?.map((itemDef) => {
//         return {
//           ...itemDef,
//           sponsor: sponsors?.find(
//             (sponsor) => sponsor.id === itemDef.sponsorId,
//           ),
//         };
//       }) || []
//     );
//   }, [itemDefs, sponsors]);

//   return {
//     itemDefs: itemDefs || [],
//     itemDefsLoading,
//     allItemDefs,
//     refreshItemDefs,
//     fetchItemDefs,
//     loading,
//     itemDefsGroupedBySponsor,
//     itemDefsWithSponsor,
//   };
// };

export default () => {
  // const { sponsors, sponsorsLoading } = useModel('sponsors', (model) => ({
  //   sponsors: model.sponsors,
  //   sponsorsLoading: model.sponsorsLoading,
  // }));

  const {
    data: itemDefs,
    loading: itemDefsLoading,
    refresh: refreshItemDefs,
  } = useRequest(async () => {
    const res = await itemDefService.getItemDefs();
    return res;
  });

  return {
    itemDefs: itemDefs || [],
    itemDefsLoading,
    refreshItemDefs,
  };
};
